import { useLingui } from '@lingui/react';
import { StatusBadge } from '@/components/ui/status-badge';
import { getSettlingInStatus, type SettlingInStage } from '@/lib/settlingInStatus';

interface SettlingInStatusBadgeProps {
  stage: SettlingInStage;
  className?: string;
}

/**
 * The one text-labelled status lozenge for a settling-in plan.
 *
 * Replaces the five near-identical check icons the list used to render, which a
 * screen reader announced as five separate icon labels and a sighted user read
 * as a wall of checks with no textual state. Shared by the list and the detail
 * stepper so the two cannot drift.
 */
export function SettlingInStatusBadge({ stage, className }: SettlingInStatusBadgeProps) {
  // useLingui() subscribes to the locale, so this re-renders on a switch. The
  // lookup is a single map hit — memoizing it would only add a dep array that
  // has to choose between the i18n instance (never recomputes on locale change)
  // and i18n.locale (which the linter then calls redundant).
  const { i18n } = useLingui();
  const style = getSettlingInStatus(stage);

  return (
    <StatusBadge tone={style.tone} icon={style.icon} label={i18n._(style.label)} className={className} />
  );
}
